
export { default } from './connected-droppable';


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/view/droppable/index.js
// module id = 1902
// module chunks = 1